import {isTmcOrderViewModel, OrderViewModel} from "../../../orders/models/OrderViewModel";
import {PriceStrategy} from "../../../components/inputs/price/input/PriceStrategy";
import {isIressOrderModel} from "../../../orders/models/iress/IressOrderViewModel";
import {isSimulatedOrderModel} from "../../../orders/models/simulated/SimulatedOrderViewModel";
import {OrderSide} from "../../../orders/models/OrderRecord";

export type FooterOrders = ReadonlyArray<FooterOrder>;

export class FooterOrder {

    public readonly orderIdentifier: string;

    private constructor(public readonly model: OrderViewModel) {
        this.orderIdentifier = FooterOrder.generateOrderIdentifier(model);
    }

    private static generateOrderIdentifier(model: OrderViewModel): string {
        if (isIressOrderModel(model)) {
            return `IRESS:${model.serverName}:${model.orderNumber}`;
        } else if (isSimulatedOrderModel(model)) {
            return `SIMULATED:${model.id}`;
        } else {
            throw Error(`Unable to make identifier for model type ${typeof model}`);
        }
    }

    public get code(): string {
        return this.model.code;
    }

    public get side(): OrderSide {
        return this.model.side;
    }

    public get quantity(): number {
        return this.model.quantity;
    }

    public get limit(): number {
        return this.model.limit!;
    }

    public get theo(): number | null {
        return this.model.theo;
    }

    public get priceStrategy(): PriceStrategy {
        return this.model.priceStrategy;
    }

    public get hasQuote(): boolean {
        return this.model.hasQuote;
    }

    public get isBuy(): boolean {
        if (isTmcOrderViewModel(this.model)) {
            return true;
        } else {
            return this.model.side === OrderSide.BUY;
        }
    }

    public get isSell(): boolean {
        if (isTmcOrderViewModel(this.model)) {
            return false;
        } else {
            return this.model.side !== OrderSide.BUY;
        }
    }

    public static from(modelOrModels: ReadonlyArray<OrderViewModel>): FooterOrders;
    public static from(modelOrModels: OrderViewModel): FooterOrder;

    public static from(modelOrModels: any): any {
        if (Array.isArray(modelOrModels)) {
            return modelOrModels.map((m) => new FooterOrder(m));
        } else {
            return new FooterOrder(modelOrModels);
        }
    }
}
